import locationComponent from './location.component';
import LocationCreate from './create'
import LocationEdit from './edit'
import LocationAll from './all'
import LocationMissinglatlng from './missinglatlng'
import DeliverLocationComponent from './common/deliver_location/deliver_location.component';
import ImportLocations from './import_locations';
import LocationClone from './clone';
import printLocationBarcodesModule from './print'

let locationModule = angular.module('location', [
    LocationCreate,
    LocationEdit,
    LocationAll,
    LocationMissinglatlng,
    ImportLocations,
    LocationClone,
    printLocationBarcodesModule
  ])

  .component('location', locationComponent)
  .component('deliverLocation', DeliverLocationComponent)
  
  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('location.edit', {
        url: '/edit/:id',
        component: 'locationedit',
        data: {
          requireACL: 'setting-location.edit'
        }
      })

      .state('location.create', {
        url: '/create',
        component: 'locationcreate',
        data: {
          requireACL: 'setting-location.create'
        }
      })

      .state('location.all', {
        url: '/all/:page',
        component: 'locationall',
        data: {
          requireACL: 'setting-location.view'
        }
      })

      .state('location.missinglatlng', {
        url: '/missinglatlng/:page',
        component: 'locationMissinglatlng',
        data: {
          requireACL: 'setting-location.view'
        }
      })

      .state('location.import_locations', {
        url: '/import-locations/:page',
        component: 'importLocations',
        data: {
          requireACL: 'setting-location.importLocations'
        }
      })

      .state('location.clone', {
        url: '/clone',
        component: 'locationclone',
        data: {
          requireACL: 'setting-location.clone'
        }
      })
  })

  .name;

export default locationModule;



// WEBPACK FOOTER //
// ./client/app/components/location/index.js